import { InjectionToken } from '@angular/core';

export const STATIC_TEXT_TOKEN = new InjectionToken<T.StaticTexts>('STATIC_TEXTS');
